import MembershipDetailForC2 from "./MembershipDetailForC2";

export default MembershipDetailForC2;
